export default {"src":"/_next/static/media/Timings.f2040984.svg","height":22,"width":30};